import { trackSegmentAndGAEvent } from '@zoopla/tracking';

const eventCategory = 'situation';

export const trackQuestionShown = (
    questionName: string,
    page: string,
    trackingIdentifier?: string
) => {
    trackSegmentAndGAEvent(
        'Module Shown',
        {
            eventCategory,
            eventAction: 'module_shown',
            eventLabel: `${trackingIdentifier}${questionName}`
        },
        page
    );
};

export const trackQuestionSaved = (
    questionName: string,
    value: string,
    page: string,
    trackingIdentifier?: string
) => {
    trackSegmentAndGAEvent(
        'My Situation Submission',
        {
            eventCategory,
            eventAction: 'click',
            eventLabel: `${trackingIdentifier}${questionName}: ${value}`
        },
        page
    );
};

export const trackQuestionEdit = (
    questionName: string,
    value: string,
    page: string,
    trackingIdentifier?: string
) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory,
            eventAction: 'click',
            eventLabel: `${trackingIdentifier}${questionName}: ${value} edit`
        },
        page
    );
};

export const trackQuestionError = (
    questionName: string,
    value: string,
    page: string,
    trackingIdentifier?: string
) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory,
            eventAction: 'error_shown',
            eventLabel: `${trackingIdentifier}${questionName}: ${value}`
        },
        page
    );
};
